import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import ArticlePage from "@/pages/article/page";
import ArticleScarpe from "@/pages/article-scarpe/page";
import ArticleSicurezza from "@/pages/article-sicurezza/page";
import ArticleCategorie from "@/pages/article-categorie/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/articolo-guida-itaobuy-spreadsheet",
    element: <ArticlePage />,
  },
  {
    path: "/articolo-itaobuy-spreadsheet-scarpe",
    element: <ArticleScarpe />,
  },
  {
    path: "/articolo-itaobuy-spreadsheet-sicurezza",
    element: <ArticleSicurezza />,
  },
  {
    path: "/articolo-itaobuy-spreadsheet-categorie",
    element: <ArticleCategorie />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;